import { ConfirmDialogRoot } from "./ConfirmDialog";
import { ConfirmDialogTitle } from "./ConfirmDialogTitle";
import { ConfirmDialogBody } from "./ConfirmDialogBody";
import { ConfirmDialogActions } from "./ConfirmDialogActions";

export const ConfirmDialog = Object.assign(ConfirmDialogRoot, {
  Title: ConfirmDialogTitle,
  Body: ConfirmDialogBody,
  Actions: ConfirmDialogActions,
});

export { useConfirmDialogContext } from "./ConfirmDialogContext";
export type {
  ConfirmDialogProps,
  ConfirmDialogTitleProps,
  ConfirmDialogBodyProps,
  ConfirmDialogActionsProps,
  ConfirmDialogContextValue,
} from "./types";
